import getImageOrientation from './get-image-orientation';
import getImageSize from './get-image-size';
import getNewAssetSrc from './get-new-asset-src';
import addBaseHref from './add-base-href';
import fetchWsAsset from './fetch-ws-asset';
import resetImageExifOrientation from './reset-image-exif-orientation';
import composeWsAssetUrl from './compose-ws-asset-url';
import downloadExternalAssets from './download-external-assets';
import copyFromCdn from './copy-from-cdn';

export default {
  getImageOrientation,
  getImageSize,
  getNewAssetSrc,
  addBaseHref,
  resetImageExifOrientation,
  fetchWsAsset,
  composeWsAssetUrl,
  downloadExternalAssets,
  copyFromCdn,
};
